import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col max-w-[812px] gap-6 py-4 mx-auto"
}
const _hoisted_2 = { class: "flex" }

import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import LoaderIcon from "@/components/icons/LoaderIcon.vue";
import { fetchChineseCalendarDay } from "@/api/calculators";
import { ChineseCalendarDay } from "@/types/calculators";
import DayParamsCardComponent from "@/views/Calculators/ChineseCalendar/components/DayParamsCardComponent.vue";
import DaySummaryCardComponent from "@/views/Calculators/ChineseCalendar/components/DaySummaryCardComponent.vue";
import { useI18n } from "vue-i18n";
import DayHoursTableComponent from "@/views/Calculators/ChineseCalendar/components/DayHoursTableComponent.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import { useSafeBack } from "@/utils/useSafeBack";
import { ROUTE_NAMES } from "@/constants/routeNames";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChineseCalendarDayView',
  setup(__props) {

const route = useRoute();
const { t } = useI18n();
const { safeBack } = useSafeBack();

const waitApiCall = ref(true);
const calendarDay = ref<ChineseCalendarDay>();
const queryDate = ref<string>();

onMounted(async () => {
  queryDate.value = route.query.date as string;
  calendarDay.value = await fetchChineseCalendarDay(queryDate.value);
  waitApiCall.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-full xl:h-screen w-full pt-6 xl:pt-[88px] px-4 overflow-y-auto no-scrollbar", { 'flex flex-col justify-center': waitApiCall.value }])
  }, [
    (waitApiCall.value)
      ? (_openBlock(), _createBlock(LoaderIcon, {
          key: 0,
          spinnerColor: "brown",
          class: "mx-auto"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(BackButton, {
              onClicked: _cache[0] || (_cache[0] = ($event: any) => (_unref(safeBack)(_unref(ROUTE_NAMES).HOME)))
            }, {
              "back-text": _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.return-to-month")), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(DayParamsCardComponent, {
            date: queryDate.value,
            dayParams: calendarDay.value
          }, null, 8, ["date", "dayParams"]),
          (calendarDay.value.new_season == undefined)
            ? (_openBlock(), _createBlock(DaySummaryCardComponent, {
                key: 0,
                cardTitle: _unref(t)('calculators.chinese-calendar-day.day-summary.title'),
                dayParams: calendarDay.value
              }, null, 8, ["cardTitle", "dayParams"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(DaySummaryCardComponent, {
                  cardTitle: 
            _unref(t)('calculators.chinese-calendar-day.day-summary.season-before', {
              season: calendarDay.value.season.current,
              time: calendarDay.value.season.change_time,
            })
          ,
                  dayParams: calendarDay.value
                }, null, 8, ["cardTitle", "dayParams"]),
                _createVNode(DaySummaryCardComponent, {
                  cardTitle: 
            _unref(t)('calculators.chinese-calendar-day.day-summary.season-after', {
              season: calendarDay.value.season.new,
              time: calendarDay.value.season.change_time,
            })
          ,
                  dayParams: calendarDay.value.new_season
                }, null, 8, ["cardTitle", "dayParams"])
              ], 64)),
          _createVNode(DayHoursTableComponent, {
            hoursTable: calendarDay.value.hours_table
          }, null, 8, ["hoursTable"])
        ]))
  ], 2))
}
}

})